import axios from "axios";
import { useState } from "react";
import { baseUrl } from "../enum/constant";
import { Link } from "react-router-dom";
import ContactLinks from "./contactLinks";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    email: "",
    description: "",
    wallet_id: "",
    attachment: null,
    checkbox: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const isNotValid = () => {
    if (
      formData.email &&
      formData.description &&
      formData.wallet_id &&
      formData.checkbox === true
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 5 * 1024 * 1024) {
      setError("File size must not exceed 5MB.");
      setFormData((prevState) => ({ ...prevState, attachment: null }));
    } else {
      setError("");
      setFormData((prevState) => ({ ...prevState, attachment: file }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // if (!formData.attachment) {
    //     setError("Attachment is required and must be less than 5MB.");
    //     return;
    // }

    // const data = new FormData();
    // data.append("email", formData.email);
    // data.append("description", formData.description);
    // data.append("wallet_id", formData.wallet_id);
    // data.append("attachment", formData.attachment);

    try {
      setLoading(true);
      const base = baseUrl;
      const response = await axios.post(base + "api/RequestForm", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSuccess("Request submitted successfully!");
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
      setFormData({
        email: "",
        description: "",
        wallet_id: "",
        attachment: null,
      });
    } catch (err) {
      if (err.response && err.response.data.errors) {
        setError(Object.values(err.response.data.errors).join(", "));
      } else {
        setError("Failed to submit the request. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <!--hero part start here!--> */}

      <section className="hearo-wrap hero-inner">
        <div className="container">
          {/* <!--=========Bread Crum!=====================--> */}
          <div className="bread-crum">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Contact
                </li>
              </ol>
            </nav>
          </div>
          {/* <!--=========Bread Crum!=====================--> */}
        </div>

        <div className="container hero-bx padding-top-bot mobile-p-t">
          {/* <!--exchange part!--> */}

          <div className="row justify-content-center">
            <div className="col-md-7">
              <h1 className="hero-title top-title">
                Contact <br />
                the Kittrow Investments s.r.o. Team
              </h1>
            </div>
          </div>
        </div>
        {/* <!--exchange part!--> */}
      </section>

      {/* <!--===================Contact page!======================--> */}

      <section className="container cont-form">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="form-part">
              {/* <!--=============contact form start here!=====================--> */}
              <div className="tab-part">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="support"
                      data-toggle="tab"
                      href="#support"
                      role="tab"
                      aria-controls="support"
                      aria-selected="true"
                    >
                      Support Ticket
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="business"
                      data-toggle="tab"
                      href="#business"
                      role="tab"
                      aria-controls="business"
                      aria-selected="false"
                    >
                      Business inquiry{" "}
                    </a>
                  </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="support"
                    role="tabpanel"
                    aria-labelledby="support"
                  >
                    <div className="fomr-part">
                      <h3>Submit a request</h3>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="fm-outer">
                              <label>Email Address*</label>
                              <input
                                className="fm-cont"
                                type="email"
                                placeholder="example@gmail.com"
                                id="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                              {/* <div className='error'><span>Validation will sow here developr will update this and hide this.</span></div> */}
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="fm-outer">
                              <label>Wallet ID</label>
                              <input
                                className="fm-cont"
                                type="text"
                                placeholder="OxABC123..."
                                id="wallet_id"
                                value={formData.wallet_id}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="fm-outer">
                              <label>Description*</label>
                              <textarea
                                className="fm-cont"
                                placeholder="Pease enter the details of your request. A member of our support staff will respond..."
                                id="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                              ></textarea>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                required
                                className="custom-control-input"
                                id="customCheck1"
                                checked={formData.checkbox}
                                onChange={(e) => {
                                  setFormData((prev) => ({
                                    ...prev,
                                    checkbox: e.target.checked,
                                  }));
                                }}
                              />
                              <label
                                className="custom-control-label"
                                for="customCheck1"
                              >
                                I accept the <Link to="/terms-of-use">Terms & conditions</Link>
                              </label>
                            </div>
                          </div>
                        </div>

                        {error && <p className="text-danger">{error}</p>}
                        {success && <p className="text-success">{success}</p>}
                        <div className="button-group">
                          <button
                            type="submit"
                            className="btn blue-btn"
                            disabled={loading || isNotValid()}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="business"
                    role="tabpanel"
                    aria-labelledby="business"
                  >
                    2
                  </div>
                </div>
              </div>
            </div>
            {/* <!--=============contact form start here!=====================-->	 */}
          </div>
        </div>

        <div className="sec-pad-t"></div>
        <ContactLinks />
      </section>

      <div className="sec-pad-t"></div>
      {/* <!--=============Spacer!===========--> */}
    </>
  );
};

export default ContactUs;
